const fn = window.Raven ? window.Raven.captureBreadcrumb : null;

// NOTE: Use plugin presets
const consolePresets = {};

// NOTE: `vue-log` config for Raven
const ravenPresets = {
    logger: window.Raven,
    proxy: false,
    levels: [
        { name: 'debug', fn },
        { name: 'info', fn },
        { name: 'warn', fn },
        { name: 'error', fn },
    ],
    loggerArgs({ level, config, statements }) {
        return [
            {
                category: 'vue-log',
                level: level.name,
                data: {
                    message: statements.toString ? statements.toString() : '',
                    ...config.context,
                },
            },
        ];
    },
};


export default (globals.config.debug ? consolePresets : ravenPresets);
